import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconPin(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <g clipPath="url(#icon-pin)">
        <path
          d="m19.07 7.757-3.535 3.536a4.985 4.985 0 0 0-1.414 2.828L9.878 9.88a4.943 4.943 0 0 0 2.829-1.415l3.535-3.535 2.829 2.828Zm3.536.707-7.07-7.07a1.003 1.003 0 0 0-1.415 0 1.003 1.003 0 0 0 0 1.414l.707.707-3.535 3.535a2.996 2.996 0 0 1-4.243 0L5.636 8.464l4.221 4.222-4.95 4.95v1.414h1.415l4.95-4.95 4.263 4.264 1.415-1.414a2.996 2.996 0 0 1 0-4.243l3.535-3.535.707.707a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.415Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="icon-pin">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
}
